package com.solevo.dist.network.firebase.api.products

import com.solevo.dist.application.models.Product
import com.solevo.dist.application.models.User.Companion.legalId
import com.solevo.dist.network.api.products.ProductRemoteSource
import com.solevo.dist.network.firebase.api.products.models.FirebaseProduct
import com.solevo.dist.network.firebase.api.products.models.toProduct
import com.solevo.dist.network.implementation.firebase.FirebaseFields
import com.solevo.dist.network.implementation.firebase.FirestoreCollections
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.firestore.where
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.mapNotNull

class ProductFirestoreRemoteSource : ProductRemoteSource {

    private val firestore = Firebase.firestore

    override fun getProducts(ids: List<String>): Flow<List<Product>> {
        if (ids.isEmpty()) return kotlinx.coroutines.flow.flow { emit(emptyList()) }
        return firestore.collection(FirestoreCollections.PRODUCTS_COLLECTION)
            .where { FirebaseFields.LEGAL_ENTITY_ID equalTo legalId }
            .snapshots
            .map { q ->
                q.documents
                    .mapNotNull { it.data<FirebaseProduct?>() }
                    .map { it.toProduct() }
                    .filter { ids.contains(it.productId) }
            }
    }

    override fun getProductDetailsLive(productId: String): Flow<Product> {
        return firestore.collection(FirestoreCollections.PRODUCTS_COLLECTION)
            .where { FirebaseFields.PRODUCT_ID equalTo productId }
            .where { FirebaseFields.LEGAL_ENTITY_ID equalTo legalId }
            .snapshots
            .mapNotNull { q ->
                q.documents.firstNotNullOfOrNull { it.data<FirebaseProduct?>() }
                    ?.toProduct()
            }
    }

    override suspend fun getProductDetails(productId: String): Result<Product?> {
        return runCatching {
            val q = firestore.collection(FirestoreCollections.PRODUCTS_COLLECTION)
                .where {
                    all(
                        FirebaseFields.PRODUCT_ID equalTo productId,
                        FirebaseFields.LEGAL_ENTITY_ID equalTo legalId
                    )
                }
                .get()
            q.documents.firstOrNull()?.data<FirebaseProduct?>()?.toProduct()
        }
    }
}


